import { EmptyState, ErrorBoundary, FlexBox } from '@dixa/lib-shared-habla';
import { Navigate, Route, Routes } from 'react-router-dom';

import { TvDashboardView } from './tvDashboard.view';
import { TvChannelDashboardView } from './views/channel';
import { TvOrganizationDashboardView } from './views/organization';
import { TvQueueDashboardView } from './views/queue';

export const TvDashboardRoutes = (): JSX.Element => {
  return (
    <Routes>
      <Route
        path="*"
        element={
          <ErrorBoundary
            fallback={
              <FlexBox
                height="100%"
                alignItems="center"
                justifyContent="center"
              >
                <EmptyState
                  title="Something went wrong"
                  description="The dashboard is currently unavailable due to an unexpected
            error. Our team has been notified and is looking into the
            issue."
                  icon="exclamation"
                  iconColor="red.500"
                  buttonProps={{
                    variant: 'primary',
                    children: 'Try reloading',
                    onClick: () => window.location.reload(),
                  }}
                />
              </FlexBox>
            }
          >
            <TvDashboardView />
          </ErrorBoundary>
        }
      >
        <Route index element={<Navigate to="organization" replace />} />

        <Route path=":queueId" element={<TvQueueDashboardView />} />

        <Route path="channels/:media" element={<TvChannelDashboardView />} />

        <Route path="organization" element={<TvOrganizationDashboardView />} />
      </Route>
    </Routes>
  );
};
